<template>
    <div>
        <Loader ref="Loader"></Loader>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <YesNoModal ref="YesNoModal"></YesNoModal>
        <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card>
                <v-toolbar dense color="secondary" dark>
                    <v-toolbar-title>Feedback</v-toolbar-title>
                </v-toolbar>
                <v-container>
                    <v-flex xs12>
                        <v-form ref="form">
                            <v-layout row>
                                <v-flex xs6 mr-2>
                                    <v-select label="Feedback type" :items="FeedbackTypes" item-text="Name"
                                        item-value="ID" v-model="CustomerFeedbackForm.Type">
                                    </v-select>
                                </v-flex>
                                <!-- <v-flex xs6 mr-2>
                                        <v-select label="Role" :items="RoleItems" item-text="Name" item-value="ID"
                                            v-model="CustomerFeedbackForm.RoleID">
                                        </v-select>
                                    </v-flex> -->
                                <v-flex>
                                    <v-btn small fab color="secondary" v-model="CustomerFeedbackForm.Image"
                                        @click="addFile">
                                        <v-icon>add_a_photo</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12>
                                    <v-textarea outline label="Comments" v-model="CustomerFeedbackForm.Comments">
                                    </v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-btn color="primary" @click="Submit()">Submit</v-btn>
                            </v-layout>
                        </v-form>
                        <input @change="readURL" style="display: none" ref="fileInput" type="file">
                    </v-flex>
                </v-container>
            </v-card>
        </v-flex>
    </div>
</template>

<script>
    import JWT from "jsonwebtoken";
    import moment from 'moment';

    export default {
        data() {
            let self = this;
            return {
                FeedbackTypes: [{
                    ID: 1,
                    Name: "Request"
                }, {
                    ID: 2,
                    Name: "Complaint"
                }, {
                    ID: 3,
                    Name: "Compliment"
                }],
                RoleItems: [],
                CustomerFeedbackForm: {
                    CustomerID: 0,
                    RoleID: 0,
                    Type: 0,
                    SystemUserIdList: [],
                    DateSent: moment(Date.now()),
                    Image: null,
                    Comments: "",
                    Status: 1,
                    DateResolved: null,
                    ResolvedComments: ""
                },
                accountID: 0,
                userID: 0,
                ProcessImage: null,
                imageBytes: null
            }
        },
        mounted() {
            let self = this;

            let tokenDecoded = JWT.decode(localStorage.accessToken);
            console.log(tokenDecoded)
            self.accountID = tokenDecoded.ACCOUNT_ID;
            self.userID = tokenDecoded.USER_ID;
            console.log("USER_ID", self.userID);

            self.FetchRoles();
        },
        methods: {
            FetchRoles() {
                let self = this;

                self.get(`Roles/Account?accountID=${self.accountID}`).then(r => {
                    self.RoleItems = r.data;
                })
            },
            addFile() {
                let self = this;
                self.$refs.fileInput.click();
            },
            readURL(e) {
                let self = this;
                self.blobToDataURL(e.target.files[0], function (dataurl) {
                    self.newImage = dataurl;
                    self.blobToArrayBuffer(e.target.files[0], function (result) {
                        console.log("IMAGE BEFORE", result)
                        self.CustomerFeedbackForm.Image = Array.from(new Uint8Array(
                            result));
                        self.imageBytes = Array.from(new Uint8Array(
                            result));
                        console.log("IMAGE AFTER", self.CustomerFeedbackForm.Image)
                    });

                })
            },
            blobToArrayBuffer(blob, callback) {
                var a = new FileReader();
                a.onload = function (e) {
                    callback(a.result);
                }
                a.readAsArrayBuffer(blob);
            },
            blobToDataURL(blob, callback) {
                var a = new FileReader();
                a.onload = function (e) {
                    callback(e.target.result);
                }
                a.readAsDataURL(blob);
            },
            getAdminRole() {
                let self = this;

                let roleItem = self.RoleItems.filter(role => {
                    return role.OpsManager == true;
                })

                if (roleItem.length > 0) {
                    return roleItem[0];
                } else {
                    return null;
                }
            },
            Submit() {
                let self = this;

                let role = self.getAdminRole();
                self.CustomerFeedbackForm.RoleID = role.ID;
                self.CustomerFeedbackForm.CustomerID = self.userID;
                self.CustomerFeedbackForm.Image = self.imageBytes;

                console.log("form", self.CustomerFeedbackFormZ)
                self.$nextTick(() => {
                    self.post('CustomerFeedbackTask/ComplexPost', self.CustomerFeedbackForm).then(r => {
                        console.log("[FEEDBACK POST RESPONSE]", r.data)
                        self.CustomerFeedbackForm.Image = null;
                        self.CustomerFeedbackForm.Comments = null;
                        self.$refs.SuccessModal.show();
                        self.$refs.SuccessModal.setText("Feedback sent!");
                        setTimeout(function () {
                            self.$refs.SuccessModal.hide();
                        }, 800)
                    })
                })
            }
        }
    }
</script>

<style>

</style>